<template>
  <div>
    <v-card flat>
      <v-toolbar dense flat color="grey"> File Upload</v-toolbar>
      <v-row class="pl-5">
        <v-col cols="12" md="12">
          <v-card flat>
            <v-row>
              <v-col cols="12" md="6">
                <v-select
              :items="DocType"
              v-model="SeltemplateID"
              label="Select Document"

              dense
              outlined
              hide-details
            ></v-select>
          </v-col>
          <v-col cols="12" md="6">
            <v-btn
                color="primary"
               
              
                @click="downloadFile"
              >
                Download
              </v-btn>
             
            </v-col>

              </v-row>
           

            <v-list>
              <v-file-input
                v-model="selectedFile"
                label="Choose a file"
                outlined
                show-size
                prepend-icon="mdi-upload"
                @change="onFileSelected"
              ></v-file-input>

              <!-- Upload Button -->
              <v-btn
                color="primary"
                class="mt-3"
                :disabled="!selectedFile"
                @click="uploadFile"
              >
                Upload
              </v-btn>

              <v-alert
                v-if="uploadStatus"
                type="success"
                class="mt-3"
                border="left"
                elevation="2"
              >
                {{ uploadStatus }}
              </v-alert>
            </v-list>
          </v-card>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
export default {
  data: () => ({
    fileUrl: "https://accred.api.dnanetworks.in/",
    subUrl:"",
    selectedFile: null,
    uploadStatus: "",
    overlay: false,
    SeltemplateID: "",

    DocType: [
      { text: "Approved", value: "approved" },
      { text: "Amended", value: "amended" },
      { text: "Admin-Manual", value: "Admin-Manual" },
      { text: "Application-Manual", value: "Application-Manual" },
      { text: "Event- Logo", value: "logo" },
      { text: "Event- Header", value: "header" },
      { text: "Event- BG(Image/Video)", value: "bg" },
      { text: "Media Registration", value: "mediaregistration" },
      { text: "Media Confirmation", value: "mediaconfirmation" },
      { text: "Media Rejected", value: "mediarejected" },
      { text: "Otp", value: "otp" },
      { text: "Register", value: "register" },
      { text: "Rejected", value: "rejected" },
      { text: "Schedule", value: "Schedule" },
      { text: "Schedule", value: "Schedule" },
      { text: "T & C- Local", value: "local" },
      { text: "T & C- Media", value: "media" }
    ],
  }),
 


  mounted() {
    //console.log("HI");
    console.log("check now",this.$store.state.eventInfo.EventURL);
    this.$store.commit("setPageTitle", this.$store.state.eventInfo.EventName);

    this.Reload();
  },
  methods: {

    async downloadFile() {
      if (!this.fileUrl) {
        alert("Please enter a valid file URL");
        return;
      }
      try {
       // const subUrl = "";

        if(this.SeltemplateID=="local" || this.SeltemplateID=="media")
      {
        this.subUrl="/tnc/" + this.SeltemplateID + ".html";
      }
      else if(this.SeltemplateID=="approved" || this.SeltemplateID=="amended" || this.SeltemplateID=="rejected")
      {
        this.subUrl="/Emailers/" + this.SeltemplateID + ".html";
      }
      else if(this.SeltemplateID=="otp" || this.SeltemplateID=="mediaregistration" || this.SeltemplateID=="register")
      {
        this.subUrl="/Emailers/" + this.SeltemplateID + ".html";
      }
      else if(this.SeltemplateID=="mediarejected" || this.SeltemplateID=="mediaconfirmation")
      {
        this.subUrl="/Emailers/" + this.SeltemplateID + ".html";
      }
      else if(this.SeltemplateID=="Admin-Manual" || this.SeltemplateID=="Application-Manual")
      {
        this.subUrl="/" + this.SeltemplateID + ".pdf";
      }

      else if(this.SeltemplateID=="Schedule")
      {
        this.subUrl="/tnc/" + this.SeltemplateID + ".pdf";
      }

      else if(this.SeltemplateID=="logo" || this.SeltemplateID=="bg" || this.SeltemplateID=="header")
      {
        this.subUrl="/" + this.SeltemplateID + ".jpg";
      }

      

        const response = await fetch(this.fileUrl + "Assets/" + this.$store.state.eventInfo.EventURL + this.subUrl , { mode: "cors" });
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;

        // Try to extract filename from URL
        let filename = this.fileUrl.split("/").pop() || this.SeltemplateID;



        if (/\.htm$/i.test(filename)) {
  filename = filename.replace(/\.htm$/i, ".html");
}
if (
  this.SeltemplateID.endsWith("local") ||
  this.SeltemplateID.endsWith("media") ||
  this.SeltemplateID.endsWith("approved") ||
  this.SeltemplateID.endsWith("amended") ||
  this.SeltemplateID.endsWith("rejected") ||
  this.SeltemplateID.endsWith("otp") ||
  this.SeltemplateID.endsWith("mediaregistration") ||
  this.SeltemplateID.endsWith("register") ||
  this.SeltemplateID.endsWith("mediarejected") ||
  this.SeltemplateID.endsWith("mediaconfirmation")
) {
  if (!filename.endsWith(".html")) filename += ".html";
}



        link.setAttribute("download", filename);

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // Cleanup
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error("Download failed:", error);
        alert("Failed to download file");
      }
    },
 
    async uploadFile() {
      if (!this.selectedFile) return;

      try {
        const formData = new FormData();
        formData.append("file", this.selectedFile);

        // Example: using fetch (replace URL with your backend endpoint)
        const response = await fetch(
          "https://accred.api.dnanetworks.in/Event/UploadEmailTemplate/" +
          this.$store.state.eventInfo.EventURL +
            "/" +
            this.SeltemplateID,
          {
            method: "POST",
            headers: {
              appkey: "ticketgenieapikey", // 👈 custom header
            },
            body: formData,
          }
        );

        if (response.ok) {
          console.log(response);
          this.uploadStatus = "✅ File uploaded successfully!";
        } else {
          this.uploadStatus = "❌ File upload failed!";
        }
      } catch (error) {
        console.error(error);
        this.uploadStatus = "⚠️ Error uploading file!";
      }
      
    },

    onFileSelected(file) {
      this.uploadStatus = "";
      console.log("Selected file:", file);
    },
  },
};
</script>

<style>
</style>